import { render, staticRenderFns } from "./DemoWalkthroughPageLayout.vue?vue&type=template&id=622fc814&scoped=true&"
import script from "./DemoWalkthroughPageLayout.vue?vue&type=script&lang=js&"
export * from "./DemoWalkthroughPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./DemoWalkthroughPageLayout.vue?vue&type=style&index=0&id=622fc814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fc814",
  null
  
)

export default component.exports